import {
  GetCollegePredictorResponseSchema,
  GetCollegePredictorResponseType
} from '@nw/shared/data-access';
import { validateApiResponseWithZod } from '@nw/shared/utils';

import { PredictedCollegesDetailDTO } from '../../dtos/collegePredictor.dtos';

export const getPredictedCollegeDataTransformer = (
  data: GetCollegePredictorResponseType
): PredictedCollegesDetailDTO => {
  const validateResponse = validateApiResponseWithZod(
    data,
    GetCollegePredictorResponseSchema
  ) as GetCollegePredictorResponseType;

  const { total_no_of_colleges, admission_category_name, colleges } =
    validateResponse;

  const transformedData: PredictedCollegesDetailDTO = {
    totalNoOfColleges: total_no_of_colleges,
    admissionCategoryName: admission_category_name,
    colleges: colleges.map((college) => ({
      collegeId: college.college_id,
      collegeName: college.college_name,
      collegeAddress: college.college_address,
      extraInfo: college.extra_info || null,
      isPromoted: college.is_promoted,
      branches: college.branches.flatMap((branch) => {
        if (branch.reservation_categories?.length) {
          return branch.reservation_categories.map((reservationCategory) => ({
            branchCode: branch.branch_code,
            branchName: branch.branch_name,
            fee: branch.fee || null,
            cutOff: reservationCategory.cutoff
              ? Number(reservationCategory.cutoff)
              : branch.cutoff || 0,
            extraInfo: reservationCategory.extra_info || null
          }));
        }
        return [
          {
            branchCode: branch.branch_code,
            branchName: branch.branch_name,
            fee: branch.fee || null,
            cutOff: branch.cutoff || 0,
            extraInfo: null
          }
        ];
      })
    }))
  };

  return transformedData;
};
